<template>
    <div class="modal fade" id="advertisementContact" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true" style="overflow-y: hidden;padding-left: 0">
        <div class="modal-dialog modal-lg">
            <div class="modal-content custom-modal">
                <div class="row justify-content-center">
                    <div class="col-10">
                        <div class="d-flex align-items-center justify-between py-4">
                            <p class="text-20 color-dark-blue extra-bold mb-0" data-contact> {{ fullTitle }} </p>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                    </div>
                </div>

                <div class="bg-my-account py-3 px-5 px-lg-0">
                    <div class="row justify-content-center">
                        <div class="col-md-8">
                            <div class="row justify-content-between align-items-center mb-3">
                                <div class="col-auto">
                                    <p class="mb-0 color-gray-AC responsive-text-14 font-weight-800">
                                        {{ advertisement.subtitle }}
                                    </p>
                                    <p class="mb-0 color-gray-7070 responsive-text-16 font-weight-bold">
                                        {{ advertisement.phone }}
                                    </p>
                                </div>

                                <div class="col-4 text-center">
                                    <img style="height: 60px; border-radius: 50%;" :src="advertisement.photo">
                                </div>
                            </div>

                            <div class="row justify-content-between align-items-center">
                                <template v-if="advertisement.title === 'Agente'">
                                    <div class="col-auto">
                                        <span class="color-primaryBlue"> {{ advertisement.company_name }}</span>
                                        <span> | AMI {{ advertisement.company_ami }}</span>
                                    </div>
                                    <div class="col-4 text-center">
                                            <span style="font-weight: 300;" class="responsive-text-12 color-464545">{{ advertisement.name_user }}</span>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="col-12">
                                        {{ advertisement.company_name }}
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row justify-content-center mt-4">
                    <div class="col-10">
                        <FormContact ref="formContact" :endpoint="route('api.advertisements.sendContact', advertisement.id)" modal-identifier="#advertisementContact"></FormContact>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {baseAdvertisement} from "@/pages/publicpages/realestate/modal-advertisement";
// import {isEmpty, isNull} from "lodash";
import FormContact from "@/vue/components/FormContact";

export default {
    name: "ModalAdvertisement",
    props: {
        advertisement: {
            type: Object,
            default: baseAdvertisement
        }
    },
    data(){
        return {
            tokenCaptcha: null,
            errors: []
        }
    },
    components: {
        FormContact
    },
    computed: {
        // siteKey() {
        //     let el = document.querySelector('input[name=siteKey]')
        //     if (el) {
        //         return JSON.parse(el.value)
        //     }
        //
        //     return process.env.MIX_INVISIBLE_RECAPTCHA_SITEKEY
        // },
        fullTitle(){
            if (this.advertisement.title === 'Agente') {
                return `Contacte o ${this.advertisement.title}`
            }

            if (this.advertisement.title === 'Agência') {
                return `Contacte a ${this.advertisement.title}`
            }

            return `Contacte ${this.advertisement.title}`
        }
    },
    methods: {
        // validateCaptcha(e, trie = 0){
        //     const _this = this;
        //     console.log('trie', trie)
        //     if (! this.advertisement.check) {
        //         return this.submit(e)
        //     }
        //
        //     if (trie > 3) {
        //         this.errors = ['Não foi possível enviar o formulário de contacto'];
        //         return false
        //     }
        //
        //     if (! window.hasOwnProperty('grecaptcha')) {
        //         return this.submit(e)
        //     }
        //
        //     window.grecaptcha.ready(function () {
        //         window.grecaptcha.execute(_this.siteKey).then(function (_token) {
        //             let token = $('[name="g-recaptcha-response"]').val();
        //             if (!token) {
        //                 token = _token;
        //             }
        //             console.log('token', token)
        //
        //             if (isNull(token) || isEmpty(token)) {
        //                 return _this.validateCaptcha(e, ++trie)
        //             }
        //
        //             _this.tokenCaptcha = token;
        //             return _this.submit(e)
        //         })
        //     })
        //
        //     return false
        // },
        // submit(e){
        //     return e.target.closest('form').submit()
        // }
    }
}
</script>

<style scoped>

</style>
